<template>
  <div class="container">
    <div class="title">{{ $t('doc.get_stream_title') }}</div>
    <div class="content main" v-for="(item,index) in info" :key="item.title">
      <template v-if="!item.tableData">
        <div class="listTitle">{{ item.title }}</div>
        <div :style="{color: index == 1 ? '#0077FF' : '',lineHeight: '1.5',whiteSpace: 'pre-line',wordBreak:'break-all'}">{{ item.content }}</div>
      </template>
      <template v-else>
        <div class="listTitle">
          {{ item.title }}
        </div>
        <div class="table">
          <el-table
            :data="item.tableData"
            :header-cell-style="{
              backgroundColor: '#0077FF',
              color: '#FFF',
              fontWeight: '500',
            }"
          >
            <el-table-column
              v-for="(column, index) in item.tableKey"
              :key="column"
              :prop="column"
              :label="item.tableName[index]"
            >
            </el-table-column>
            <!-- <el-table-column prop="tips" label="提示"> </el-table-column> -->
          </el-table>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenWebVideoStreaming",

  data() {
    return {};
  },
  computed: {
    // info 转 computed：文档文案随语言热切换
    info() {
      const key = ["name", "type", "require", "example", "describe"];
      const col = [this.$t("doc.col_name"), this.$t("doc.col_type"), this.$t("doc.col_require"), this.$t("doc.col_example"), this.$t("doc.col_describe")];
      return [
        { title: this.$t("doc.s_desc"), content: this.$t("doc.stream_desc") },
        { title: this.$t("doc.s_addr"), content: this.$t("doc.addr_stream") },
        { title: this.$t("doc.s_auth"), content: "token" },
        {
          title: this.$t("doc.s_req_header4"), content: "",
          tableData: [
            { name: "Authorization", type: "string", require: "Y", example: this.$t("doc.e_bearer"), describe: this.$t("doc.d_token_auth") },
          ],
          tableKey: key, tableName: col,
        },
        { title: this.$t("doc.s_req_type"), content: "post" },
        { title: this.$t("doc.s_addr_example"), content: this.$t("doc.stream_example") },
        {
          title: this.$t("doc.s_req_param6"), content: "",
          tableData: [
            { name: "sn", type: "string", require: "Y", example: "", describe: this.$t("doc.d_camera_sn") },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_resp_param7"), content: "",
          tableData: [
            { name: "code", type: "string", require: "Y", example: "", describe: this.$t("doc.d_code") },
            { name: "msg", type: "string", require: "Y", example: this.$t("doc.e_success"), describe: this.$t("doc.d_msg") },
            { name: "data", type: "object", require: "", example: "", describe: "" },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_data8"), content: "",
          tableData: [
            { name: "addressList", type: "Array", require: "N", example: "", describe: this.$t("doc.d_address_list") },
          ],
          tableKey: key, tableName: col,
        },
        {
          title: this.$t("doc.s_address_list"), content: "",
          tableData: [
            { name: "address", type: "string", require: "N", example: "", describe: this.$t("doc.d_live_address") },
            { name: "expireTime", type: "string", require: "N", example: "", describe: this.$t("doc.d_expire_time") },
          ],
          tableKey: key, tableName: col,
        },
      ];
    },
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
.title {
  padding: 10px 0;
  font-size: 24px;
  font-weight: 500;
}
.listTitle {
  font-weight: 500;
}
.main > div {
  margin: 20px 0;
  // background-color: red;
}
.table {
  width: 75%;
}
.main:last-child {
  padding-bottom: 100px;
}
</style>